// Complete React Navigation Elements Polyfill for Web
// This provides stubs for all React Navigation elements that might cause issues

import React from 'react';

export function useFrameSize() {
  return {
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  };
}

export function useHeaderHeight() {
  return 56;
}

export function Header({ children, ...props }) {
  return React.createElement('div', { style: { height: 56, ...props.style } }, children);
}

export function HeaderButton({ children, onPress, ...props }) {
  return React.createElement('button', { onClick: onPress, ...props }, children);
}

export function HeaderTitle({ children, ...props }) {
  return React.createElement('span', props, children);
}

export function HeaderBackButton({ onPress, ...props }) {
  return React.createElement('button', { onClick: onPress, ...props }, '←');
}

export function HeaderBackground({ children, ...props }) {
  return React.createElement('div', props, children);
}

export function SafeAreaProviderCompat({ children }) {
  return children;
}

export function Screen({ children, ...props }) {
  return React.createElement('div', { style: { flex: 1, ...props.style } }, children);
}

export function Label({ children, ...props }) {
  return React.createElement('span', props, children);
}

export function PlatformPressable({ children, onPress, ...props }) {
  return React.createElement('div', { 
    onClick: onPress, 
    style: { cursor: 'pointer', ...props.style },
    ...props 
  }, children);
}

export function MissingIcon() {
  return React.createElement('div', { 
    style: { width: 24, height: 24, backgroundColor: '#ccc' } 
  });
}

export function getHeaderTitle(options, fallback) {
  return options?.title || fallback || '';
}

export function getDefaultHeaderHeight() {
  return 56;
}

export function getDefaultSidebarWidth() {
  return 280;
}

export function getLabel(options, routeName) {
  return options?.tabBarLabel || options?.title || routeName;
}

// Create a context for HeaderBack
export const HeaderBackContext = React.createContext({
  title: '',
});

// Export all as default object
export default {
  useFrameSize,
  useHeaderHeight,
  Header,
  HeaderButton,
  HeaderTitle,
  HeaderBackButton,
  HeaderBackground,
  SafeAreaProviderCompat,
  Screen,
  Label,
  PlatformPressable,
  MissingIcon,
  getHeaderTitle,
  getDefaultHeaderHeight,
  getDefaultSidebarWidth,
  getLabel,
  HeaderBackContext,
};